import React from 'react';

interface CardProps {
  className?: string;
  style?: React.CSSProperties;
}

const Card: React.FC<React.PropsWithChildren<CardProps>> = ({ children, className = '', style }) => {
  return (
    <div className={`card ${className}`} style={style}>
      {children}
    </div>
  );
};

export default Card;
